import React from "react";

import SyDialog from "../../../components/SyDialog";
import { optionKey } from "../deliveryMappers";

const DeliveryTypeSheet = ({ summary, delivery, onClose }) => {
  const lines = (summary?.carts || []).flatMap((cart) => cart.lines);

  return (
    <SyDialog
      open
      title="Choose a delivery type"
      subtitle="Only the options every supplier in your cart supports are shown."
      onClose={onClose}
    >
      <div className="sy-flow-choices" role="radiogroup" aria-label="Delivery type">
        {delivery.sharedOptions.map((option) => {
          const blocked = delivery.blockedLinesForOption(option, lines);
          const selected =
            Boolean(delivery.selectedOption) &&
            optionKey(delivery.selectedOption) === optionKey(option);

          return (
            <button
              key={optionKey(option)}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`sy-flow-choice${selected ? " is-selected" : ""}`}
              onClick={() => {
                delivery.selectKey(optionKey(option));
                onClose();
              }}
            >
              <span className="sy-flow-choice-radio" aria-hidden="true" />

              <span className="sy-flow-choice-body">
                <span className="sy-flow-choice-title">{option.title}</span>
                {option.etaText && (
                  <span className="sy-flow-choice-meta">{option.etaText}</span>
                )}

                {blocked.length > 0 && (
                  <span className="sy-flow-choice-blocked">
                    {`Not available for ${blocked.map((line) => line.name).join(", ")}`}
                  </span>
                )}
              </span>
            </button>
          );
        })}

        {!delivery.sharedOptions.length && (
          <p className="sy-flow-choice-empty">No delivery type is available for this cart.</p>
        )}
      </div>
    </SyDialog>
  );
};

export default DeliveryTypeSheet;
